import React from "react";
import "./custom-text-input.scss";
class CustomTextInput extends React.Component {
  render() {
    return (
      <div className="custom-text-input">
        <input
          type={this.props.inputType ? this.props.inputType : "text"}
          placeholder={this.props.placeholder ? this.props.placeholder : ""}
        />
      </div>
    );
  }
}

export default CustomTextInput;
